import service from '../utils/request';

// 获取权限列表
export const getPermissionList = (params) => {
  // 确保传递所有查询参数到后端
  const queryParams = {
    pageNum: params.pageNum || 1,
    pageSize: params.pageSize || 10,
    // 只有当有值时才添加到查询参数中
    ...(params.permissionName && { permissionName: params.permissionName }),
    ...(params.permissionCode && { permissionCode: params.permissionCode }),
    ...(params.permissionType && { permissionType: params.permissionType }),
    ...(params.status && { status: params.status }),
    ...(params.parentId && { parentId: params.parentId }),
  };
  
  return service.post('/permissions/query', queryParams);
};

// 获取权限树
export const getPermissionTree = () => {
  return service.get('/permissions/tree');
};

// 获取权限详情
export const getPermissionDetail = (id) => {
  return service.get(`/permissions/${id}`);
};

// 创建权限
export const createPermission = (data) => {
  return service.post('/permissions', data);
};

// 更新权限
export const updatePermission = (id, data) => {
  return service.put(`/permissions/${id}`, data);
};

// 删除权限
export const deletePermission = (id) => {
  return service.delete(`/permissions/${id}`);
};

/**
 * 启用权限
 */
export const enablePermission = (id) => {
  return service.patch(`/permissions/${id}/enable`);
};

/**
 * 禁用权限
 */
export const disablePermission = (id) => {
  return service.patch(`/permissions/${id}/disable`);
};

/**
 * 获取角色的权限列表
 */
export const getRolePermissions = (roleId) => {
  return service.get(`/permissions/role/${roleId}`);
};

/**
 * 获取所有菜单权限树
 */
export const getMenuPermissionTree = () => {
  return service.get('/permissions/menu/all-tree');
};

/**
 * 更新权限菜单树
 * @param {Object} data - 权限树结构数据
 * @param {Array} data.nodes - 权限树节点列表
 * @returns {Promise}
 */
export const updatePermissionTree = (data) => {
  return service.put('/permissions/menu/tree', data);
};

/**
 * 批量删除权限
 * @param {Array<number>} ids - 权限ID列表
 * @returns {Promise}
 */
export const batchDeletePermissions = (ids) => {
  return service.delete('/permissions/batch', { data: ids });
};

/**
 * 批量更新权限的父权限
 * @param {Object} data - 更新父权限参数
 * @param {Array<number>} data.permissionIds - 权限ID列表
 * @param {number|null} data.parentId - 父权限ID（null表示设置为根节点）
 * @returns {Promise}
 */
export const batchUpdatePermissionParent = (data) => {
  return service.put('/permissions/parent', data);
};

/**
 * 批量添加默认CRUD权限（增删改查）
 * @param {number} parentId - 父权限ID
 * @param {boolean} autoGrantSuperAdmin - 是否自动为超级管理员授权
 * @returns {Promise}
 */
export const createDefaultPermissions = (parentId, autoGrantSuperAdmin = true) => {
  return service.post(`/permissions/${parentId}/default-permissions`, {}, {
    params: {
      autoGrantSuperAdmin
    }
  });
};


